export const BUGSNAG_ENVIRONMENT = {
    'local': "DEVELOPMENT",
    'alpha-smartbiz-seller.corp.amazon.com': "DEVELOPMENT",
    'beta-smartbiz-seller.corp.amazon.com': "DEVELOPMENT",
    'gamma-smartbiz-seller.corp.amazon.com': "PRODUCTION",
    'smartbiz.amazon.in': "PRODUCTION",
}

export const BUGSNAG_API_KEY = {
    "DEVELOPMENT": "87fb161062ff7e2606c9dbffca95e5ca",
    "PRODUCTION": "6ed2c6439870c70bd16a3c12de095c11"
}

export const BUGSNAG_NOTIFY_ENDPOINT = {
    "DEVELOPMENT": "https://event.development.bugsnag.smartbiz.amazon.dev",
    "PRODUCTION": "https://event.production.bugsnag.smartbiz.amazon.dev"
}

export const BUGSNAG_SESSION_ENDPOINT = {
    "DEVELOPMENT": "https://session.development.bugsnag.smartbiz.amazon.dev",
    "PRODUCTION": "https://session.production.bugsnag.smartbiz.amazon.dev"
}

export const BUGSNAG_TRACE_ENDPOINT = {
    "DEVELOPMENT": "https://trace.development.bugsnag.smartbiz.amazon.dev/v1/traces",
    "PRODUCTION": "https://trace.production.bugsnag.smartbiz.amazon.dev/v1/traces"
}